<template>
  <div>
    <div v-if="ratedEtars" class="mb-4">
      <JcdcBadge
        color="accent"
        icon="mdi-star"
        style="position: relative; top: -6px; margin-left: -6px"
      />
      Indicates evaluations with staff ratings or comments.<br />
    </div>
    <JcdcTabs
      :key="!mobile"
      :vertical="!mobile"
      :active-tab="activeTab"
      @change="activeTab = $event"
    >
      <!-- Desktop Tabs -->
      <div v-if="!mobile">
        <div v-for="(status, index01) in statusList" :key="index01">
          <JcdcTabHeader :class="index01 > 0 ? 'mt-7' : ''">
            {{ status }} Evaluations
          </JcdcTabHeader>
          <v-expand-transition>
            <div
              v-for="(date, index02) in dateList(status)"
              v-show="expandedIndex == index01"
              :key="index02"
            >
              <JcdcTabHeader v-if="status == 'Pending'" :level="2">
                {{ formatDisplayDate(date) }}
              </JcdcTabHeader>
              <span v-for="(area, index03) in areaList(status)" :key="index03">
                <JcdcTabHeader :level="3">{{ area }}</JcdcTabHeader>
                <v-tab
                  v-for="item in filterItems(status, date, area)"
                  :key="item.evalDetId"
                  class="justify-start text-left py-3"
                  active-class="primary white--text"
                  style="text-transform: none"
                  :to="{
                    name: 'EvalTable',
                    params: {
                      evalDetId: item.evalDetId,
                      evalSummaryId: item.evalSummaryId,
                      studId: item.studId,
                      staffId: item.staffId,
                    },
                  }"
                >
                  <JcdcBadge
                    color="accent"
                    icon="mdi-star"
                    :value="staffRated(item)"
                  >
                    {{ item.evalDetailDesc }}
                  </JcdcBadge>
                </v-tab>
              </span>
            </div>
          </v-expand-transition>
          <JcdcBtn
            v-show="expandedIndex != index01"
            x-small
            color="primary"
            secondary
            outlined
            block
            transition="expand-transition"
            @click="expandedIndex = index01"
          >
            Show {{ status }}
          </JcdcBtn>
        </div>
      </div>
      <!-- Mobile Tabs -->
      <v-tab
        v-for="item in pendingEvaluations"
        v-else
        :key="item.evalDetId"
        active-class="primary white--text"
        style="text-transform: none"
        :to="{
          name: 'EvalTable',
          params: {
            evalDetId: item.evalDetId,
            evalSummaryId: item.evalSummaryId,
            studId: item.studId,
            staffId: item.staffId,
          },
        }"
      >
        <JcdcBadge color="accent" icon="mdi-star" :value="staffRated(item)">
          {{ item.evalDetailDesc }}
        </JcdcBadge>
      </v-tab>
      <!-- Tab Items -->
      <v-tabs-items>
        <v-card flat>
          <v-card-text>
            <router-view />
          </v-card-text>
        </v-card>
      </v-tabs-items>
    </JcdcTabs>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { formatDisplayDate } from '@/util/formatters'
import {
  JcdcBadge,
  JcdcBtn,
  JcdcTabHeader,
  JcdcTabs,
} from '@/components/jcdc/index'

export default Vue.extend({
  name: 'EvaluationsTab',
  components: {
    JcdcBadge,
    JcdcBtn,
    JcdcTabHeader,
    JcdcTabs,
  },
  data() {
    return {
      tabExpandToggle: true,
      expandedIndex: 0,
      ratedEtars: false,
      activeTab: undefined,
    }
  },
  computed: {
    ...mapState('evaluations', [
      'pendingEvaluations',
      'projectedEvaluations',
      'currentEvaluation',
    ]),
    ...mapGetters('evaluations', ['allEvaluations']),
    mobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    statusList() {
      return [...new Set(this.allEvaluations.map((item) => item.evalStatus))]
    },
  },
  watch: {
    // When the user double clicks on the nav link, they get a blank tab. This code fixes that. It also maintains the previous selection as the user navigates around the site. -MN
    $route(val) {
      if (val.fullPath == '/evals/evaluations') this.updateRoute()
    },
  },
  mounted() {
    if (this.$route.fullPath == '/evals/evaluations') this.updateRoute()
  },
  methods: {
    formatDisplayDate,
    updateRoute() {
      this.$router.replace({
        name: 'EvalTable',
        params: { evalDetId: this.currentEvaluation.evalDetId },
      })
    },
    dateList(status) {
      let list
      if (status == 'Pending') list = this.pendingEvaluations
      else list = this.projectedEvaluations
      return [...new Set(list.map((item) => item.evalSchedDt))]
    },
    areaList(status) {
      let list
      if (status == 'Pending') list = this.pendingEvaluations
      else list = this.projectedEvaluations
      return [...new Set(list.map((item) => item.evalArea))]
    },

    staffRated(item) {
      if (item.recordDate != '0001-01-01T00:00:00') {
        this.ratedEtars = true
        return true
      }
      return false
    },
    filterItems(status, date, area) {
      return this.allEvaluations
        .filter((s) => s.evalStatus == status)
        .filter((s) => s.evalSchedDt == date)
        .filter((s) => s.evalArea == area)
    },
  },
})
</script>
